export const manutencoesRoute: string = 'manutencao';
export const manutencoesModuleName: any = {plural: 'Manutenções', single: 'Manutenção'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/shared/data.service.ts
 **/